// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ctbO","productName":"Table_productName__3F9md"};